import * as angular from 'angular';
import { DirectiveDefinition } from '../directiveDefinition';

class TimeValidatorController implements angular.IController {
    static $inject = ['$scope', '$element'];
    static Regexp = new RegExp('^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9](:[0-5][0-9])?$');

    constructor(private _$scope: angular.IScope,
        private _$element: angular.IAugmentedJQuery) {
    }

    $onInit() {
        const ctrl = this._$element.controller('ngModel');
        ctrl.$validators.invalid = (modelValue, viewValue: string) => {
            const isValid = TimeValidatorController.Regexp.test(viewValue);
            return isValid;
        };
    }
}

export const TimeValidatorDirective: DirectiveDefinition = {
    directiveId: 'wtTimeValidator',
    restrict: 'A',
    controller: TimeValidatorController,
    require: ['ngModel']
};